import countriesData from "./countries.json";

export interface GlobalCountries {
  num_code: string;
  iso2: string;
  iso3: string;
  name: string;
  nationality: string;
}
export const getCountries = (): GlobalCountries[] => {
  return countriesData.map((country) => ({
    num_code: country.num_code,
    iso2: country.alpha_2_code,
    iso3: country.alpha_3_code,
    name: country.ar_short_name,
    nationality: country.ar_nationality,
  }));
};
